/** import scss */
import '/src/aurora/scss/style.scss';

/** Bootstrap imports */
import '/src/aurora/js/libs/bootstrap.js';

//** Swiper Global import */
import '/src/aurora/js/libs/carousels.js';

//** media-chrome video player */
import 'media-chrome'; 

/** Our JS **/
import '/src/aurora/js/modals/offsite.js'
import '/src/aurora/js/modals/daoModal.js'
import '/src/aurora/js/modals/migration.js'
import '/src/aurora/js/modals/flatModal.js'
import '/src/aurora/js/_patterns/02-organisms/top-nav.js';
import '/src/aurora/js/_patterns/02-organisms/darkmode.js';
import '/src/aurora/js/_patterns/01-molecules/carousel.js';
import '/src/aurora/js/_patterns/01-molecules/flippy-tile.js';
import '/src/aurora/js/_patterns/02-organisms/text-carousel.js'
import '/src/aurora/js/_patterns/02-organisms/carousel.js';
import '/src/aurora/js/_patterns/02-organisms/features-carousel.js';
import '/src/aurora/js/_patterns/02-organisms/personal-checking-hero.js';
import '/src/aurora/js/_patterns/02-organisms/accounts.js';
import '/src/aurora/js/_patterns/01-molecules/accordion.js';
import "/src/aurora/js/_patterns/02-organisms/button-image-carousel.js";
import '/src/aurora/js/_patterns/02-organisms/video.js';

import '/src/aurora/js/_patterns/03-pages/print-true.js';

// Login JS
